import React from 'react'
import { Switch } from 'react-router-dom/cjs/react-router-dom'
import { Route } from 'react-router-dom/cjs/react-router-dom.min'
import ModelList from './ModelList'
import ModelDetails from './ModelDetails'
import Model from './Model'
import ModelResults from './ModelResults'


const ModelContainer = ({ match }) => {



    return (
        <Switch>
            <Route exact path={`${match.path}`} component={ModelList} />
            <Route exact path={`${match.path}/create/:id`} component={Model} />
            <Route exact path={`${match.path}/job/:id`} component={ModelResults} />
            <Route exact path={`${match.path}/:id`} component={ModelDetails} />

        </Switch>

    )
}

export default ModelContainer